// extracted by mini-css-extract-plugin
module.exports = {"cqsqvjg":"cqsqvjg","l74q0k8":"l74q0k8"};